<div class="permanent-discounts" #sectionElement>
  <div class="permanent-discounts__container">
    <div class="permanent-discounts__header">
      <h2 class="permanent-discounts__title">Ahorra con Unipay en tu Supermercado favorito</h2>
      <p class="permanent-discounts__description">Descubre los descuentos adicionales que siempre tienes al pagar con Unipay</p>
    </div>

    <div class="permanent-discounts__carousel-container">
      <div class="permanent-discounts__carousel"
           (mousedown)="onMouseDown($event)"
           (mouseleave)="onMouseLeave($event)"
           (mouseup)="onMouseUp($event)"
           (mousemove)="onMouseMove($event)"
           (wheel)="onWheel($event)">
        @for (discount of permanentDiscounts; track trackByDiscountId($index, discount)) {
          <div class="permanent-discounts__card"
               [id]="'permanent-' + discount.id"
               [class.permanent-discounts__card--clickable]="isDiscountClickable(discount)"
               (click)="onDiscountClick(discount)">
            <div class="permanent-discounts__image-container">
              <img [src]="discount.img || ''"
                   [alt]="discount.titulo"
                   class="permanent-discounts__image"
                   (error)="onImageError($event, $index, 'main')" />
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</div>
